﻿angular.module("controllers").controller("descriptionUnitBaseController", function ($controller, $scope, project, itemDataService, projectService, appService, descriptionUnit) {
	$controller("projectBaseController", { $scope: $scope, project: project, itemDataService: itemDataService });
	console.log(descriptionUnit);
	$scope.descriptionUnit = descriptionUnit;
});